<template>
  <textarea
    v-if="this.type == 'textarea'"
    :id="id"
    ref="input"
    class="fsp14 lh20 neue wid border-full py10 px12 input-wrapper input-container textarea-height fw-medium"
    :style="this.style"
    :class="{ invalid: this.invalid, success: this.success }"
    :placeholder="this.place"
    :autocomplete="this.autocomplete"
    :disabled="this.disabled"
    v-on:blur="this.blur"
    v-model="this.value"
    v-on:input="this.setValue"
  ></textarea>
  <Popper 
    v-else
    :automaticOpen="true"
    :show="invalid && invalidHint" 
    :minWidthAuto="true"
    :offsetY="-10"
    :offset="'25%'"
    class="w-100"
  >
    <div class="wid position-relative form-control input-container pr4 d-flex w-100 rounded8 h40 fsp14" :class="[$attrs.class,{ 'bg-light-grey': this.disabled, 'border-red': invalid }]">
      <Icon v-if="icon" :color="iconColor" :name="icon" class="icon-left c16" />
      <input
        :id="id"
        :type="this.FactType"
        ref="input"
        :style="this.style"
        :autocomplete="this.autocomplete"
        :placeholder="this.place"
        :class="{ success: this.success, 'left-input': this.leftInput, 'pl20': icon, 'border-right': this.borderRight, 'border-0': !this.borderRight }"
        class="flex-grow-1 lh20 w-100 neue fw-medium"
        :disabled="this.disabled"
        v-model="this.value"
        v-on:blur="this.blur"
        v-on:input="this.setValue"
        v-on:keyup.enter="this.onEnter" 
      />
      <div class="d-flex align-items-center" :class="{ 'mr8': !invalid }">
        <slot></slot> 
      </div>
      <div
        v-if="this.origType == 'password' && this.value"
        class="eye-wrap"
        :class="{ not_single: this.invalid || this.success, single: !this.invalid && !this.success }"
        v-on:click="this.passVisibility" 
        :id="this.id + '-pass'"
      >
        <Icon :name="this.FactType == 'password' ? 'eye-off' : 'eye'" class="c16" />
      </div>
      <div v-if="this.invalid" class="invalid" />
    </div>
    <template #content>
      <div :id="this.id + '-invalid'">{{ this.invalidHint }}</div>
    </template>
  </Popper>
</template>

<script>
import Icon from "@/components/icons/Icon.vue";
import Popper from "@/components/service/Popper.vue";

export default {
  components: {
    Icon,
    Popper
  },
  inheritAttrs: false,
  data() {
    return {
      value: this.dataValue ? this.dataValue : "",
      place: this.placeholder ? this.placeholder : "",
      sizeW: this.$store.state.resize.w,
      FactType: this.type,
      origType: this.type,
    };
  },
  props: {
    id: [String, Boolean],
    type: [String],
    dataValue: [String, Boolean, Number],
    disabled: [String, Boolean],
    autofocus: [Boolean],
    regCheck: [Object, Boolean],
    invalid: [Boolean, String],
    success: [Boolean],
    invalidHint: [String, Boolean],
    placeholder: [String, Boolean],
    style: [Boolean, String],
    autocomplete: {
      type: [String, Boolean],
      default: "new-password",
    },
    borderRight: {
      type: Boolean,
      default: false,
    },
    leftInput: {
      type: Boolean,
      default: false,
    },
    hotUpdate: {
      default: false,
      type: [Boolean],
    },
    numOnly: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: [String, Boolean],
      default: false
    },
    iconColor: {
      type: [Boolean, Object],
      default: false,
    }
  },
  watch: {
    dataValue(newV, oldV) {
      if (this.hotUpdate) {
        this.setValue(newV, true);
      }
    },
  },
  mounted() {
    if (this.autofocus) {
      this.$nextTick(() => this.focusInput());
    }
  },
  methods: {
    setValue() {
      if (this.numOnly) {
        this.value = this.value.replace(/[^\d.]/g, "");

        const pointIndex = this.value.indexOf(".");
        if (pointIndex !== -1) {
          this.value = this.value.slice(0, pointIndex + 1) + this.value.slice(pointIndex + 1).replace(/[.]/g, "");
        }
      }
      if (this.regCheck) {
        let pre_value = this.regCheck.f(this.value);
        if (pre_value === false) {
          return;
        }
        this.value = pre_value;
      }
      this.$emit("updateParentState", {
        id: this.id,
        value: this.value,
      });
    },
    passVisibility() {
      if (this.FactType == "password") {
        this.FactType = "text";
      } else {
        this.FactType = "password";
      }
    },
    blur() {
      this.$emit("blurInput", {
        id: this.id,
        value: this.value,
      });
    },
    onEnter() {
      this.$emit("onEnter");
    },
    focusInput() {
      this.$refs.input.focus();
    },
  },
  watch: {
    dataValue(newV, oldV) {
      // if (newV != oldV) {
      // console.log(newV, oldV)
      this.value = newV ? newV : "";
      // }
    },
    autofocus(newVal) {
      if (newVal) {
        this.focusInput();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.input-wrapper {
    border-radius: 8px;
}
.invalid-feedback {
  display: block;
}
.invalid {
  border-color: $color-invalid !important;
  padding-right: calc(0.75em + 0.75rem);
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='%23dc3545'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right calc(0.2em + 0.1875rem) center;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
  box-shadow: none;
  margin-left: 8px;
}
.success {
  padding-right: calc(1.5em + 0.75rem);
  background-image: url("~@/assets/icons/check.svg");
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.1875rem) center;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
  border-color: $color-system-green;
  box-shadow: none;
}
.invalid-tooltip {
  display: block;
  z-index: 5000;
}
input::placeholder,
textarea::placeholder {
  color: $primary-grey !important;
}
input, textarea {
  outline: none;
  font-family: "HelveticaNeue roman";
}
input:disabled, textarea:disabled {
  color: $primary-grey;
}
.wid {
  width: 100%;
}

.left-input {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.input-center input {
  border-radius: 0;
}

.right-input input {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.eye-wrap {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
}

.single {
  right: 12px;
}

.not_single {
  right: 40px;
}

.icon-left {
  position: absolute;
  top: 50%;
  left: 10px;
  transform: translateY(-50%);
}
.form-control {
  padding: 4px 4px 4px 12px;
  border: 1px solid $primary-stroke;
}

.border-right {
  border: 0;
  border-right: 1px solid $primary-stroke;
  padding-right: 8px;
}

.textarea-height {
    min-height: 96px;
}

textarea {
    resize: none;
    display: block;
}

.h32 {
  height: 32px;
}

.border-red {
  border-color: $color-invalid-2 !important;
}
</style>
